import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import ReactAsyncSelect from 'react-select/async-creatable';

const DEFAULT_VALUE = { valeur: '', label: '' };
const valueToOption = ({ valeur: value, label, ...rest }) => ({
  value: value ?? '',
  label: label ?? '',
  ...rest,
});

export const CustomSelect = ({ value, onChange, ...props }) => (
  <ReactSelect
    classNamePrefix="react-select"
    isClearable={true}
    placeholder=""
    noOptionsMessage={() => 'Aucun résultat'}
    value={valueToOption(value ?? DEFAULT_VALUE)}
    onChange={(option) =>
      onChange({ valeur: option?.value ?? '', label: option?.label ?? '' })
    }
    {...props}
  />
);
CustomSelect.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

export const CustomAsyncSelect = ({ value, ...props }) => (
  <ReactAsyncSelect
    classNamePrefix="react-select"
    isClearable={true}
    placeholder=""
    noOptionsMessage={() => 'Aucun résultat'}
    loadingMessage={() => 'Chargement …'}
    value={valueToOption(value ?? DEFAULT_VALUE)}
    {...props}
  />
);
CustomAsyncSelect.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string,
  }),
};
